<template>
  <div>
    <div v-if="!sourceData.listLoading" class="filter-container" :class="source == 'download' ? 'left-filter' : ''">
      <template v-if="source !== 'download'">
        <!-- table header 筛选 -->
        <div class="filterTableHeader">
          <!-- <el-popover width="600" trigger="click">
            <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom" /></el-button>
            <div class="checkboxScrollList">
              <el-checkbox-group v-model="checkboxTitle" class="checkbox-table-headers">
                <template v-for="(item,index) in tableTheadOptions">
                  <el-checkbox v-if="item.state == '1'" :key="index" :title="item.label" :label="item.property" :disabled="index == 0">{{ item.label }}</el-checkbox>
                </template>
              </el-checkbox-group>
            </div>
          </el-popover> -->

          <el-dropdown size="small" trigger="click" placement="bottom" @command="handleCommandFilterList">
            <el-button size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom" /></el-button>
            <el-dropdown-menu slot="dropdown" class="more-dropdown">
              <el-dropdown-item v-for="item in filterList" :key="item.id" :command="item.id" :class="{'current': currentFilterId == item.id}">
                <div style="display: flex;justify-content: space-between;">
                  <div class="item-name" :title="item.name">
                    <span style="overflow: hidden;text-overflow: ellipsis;">{{ item.name }}</span>
                    <div v-if="item.isDefault" style="border-radius: 4px;background: #ebf3ff;color: #3A89FF;padding: 1px 4px;height: 20px;line-height: 20px;width: 32px;font-size: 12px;margin-left: 5px;">默认</div>
                  </div>
                  <div style="display: flex;justify-content: flex-end;">
                    <el-dropdown size="small" trigger="click" placement="bottom">
                      <span style="margin-left:12px" @click.stop="">
                        <i class="el-icon-more" />
                        <!-- <svg-icon icon-class="delete" style="font-size:16px" /> -->
                      </span>
                      <el-dropdown-menu slot="dropdown" class="more-dropdown">
                        <el-dropdown-item command="edit" @click.native="filterEdit(item)">
                          <svg-icon icon-class="edit_tmp" style="font-size:16px;margin-right: 8px;" />编辑
                        </el-dropdown-item>
                        <el-dropdown-item v-if="item.isDefault != 1" command="default" @click.native="setDefault(item)">
                          <svg-icon icon-class="file_set" style="font-size:16px;margin-right: 8px;" />设为默认
                        </el-dropdown-item>
                        <el-dropdown-item command="delete" @click.native="filterDelete(item)">
                          <svg-icon icon-class="delete" style="font-size:16px;margin-right: 8px;" />删除
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </el-dropdown-item>
              <template v-if="filterList.length < 5">
                <div v-if="filterList.length" style="width: 100%;border-top: 1px solid #E5E5E5;margin: 7px 0px" />
                <div class="dropdown-add" @click="addNewNorm">
                  <i class="el-icon-plus" style="margin-right: 5px;" />
                  新建常用自定义列
                </div>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <!-- 下载 -->
        <el-button size="small" icon="el-icon-download" style="font-size: 16px;padding:5px 15px;" title="下载" :loading="downloadLoading" @click="handleDownload" />
      </template>

      <!-- 刷新 -->
      <el-button v-else size="mini" icon="el-icon-refresh" title="刷新" @click="handleResh">刷新</el-button>

    </div>

    <!-- 表格 -->
    <el-table v-loading="sourceData.listLoading" class="grayTableTile" ref="grayTable" :header-cell-style="{fontSize:'12px'}" :data="tableList" border :show-summary="showSummary" :summary-method="summaryData"
      style="width: 100%" @sort-change="handleAgeSortChange">
      <table-item v-for="(item,index) in tableTheads" :key="index" :item-data="item" :fixed-index="index == 0" />
    </el-table>
    <!-- 分页 -->
    <pagination v-show="total>0" v-if="isPage == 1" :auto-scroll="false" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="padding: 15px 16px 8px" @pagination="getList" />

    <pagination v-show="total>0" v-else :auto-scroll="false" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="padding: 15px 16px 8px" />

    <!-- 多级表头下载 -->
    <el-table v-show="false" v-if="sourceItem.kpiType == 11" id="multiTable" ref="report-table" v-loading="sourceData.listLoading" class="grayTableTile" :header-cell-style="{fontSize:'12px'}" :data="caseTable" border
      :show-summary="showSummary" :summary-method="summaryData" style="width: 100%">
      <table-item v-for="(item,index) in tableTheads" :key="index" :item-data="item" />
    </el-table>

    <!-- 自定义列 -->
    <norm-filter ref="norm" :source-data="recordsList.parent" :source-item="sourceItem" @handleSave="handleSaveNorm" @handleSelect="handleSelectNorm" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Bus from '@Sys~/utils/bus.js'
import Pagination from '@/components/Pagination'
import TableItem from './tableItem'
import normFilter from '../normFilter'

import { arrSlice, sortKeys } from '@/filters'
import { houtaixiazai, get_header, get_headerList, delete_header, default_header } from '@Bdc~/api/ajax_model'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
export default {
  components: { Pagination, TableItem, normFilter },

  filters: {
    footerftl(value) {
      if (value == '' || value == null || value == '-') {
        return '-'
      } else {
        return value
      }
    }
  },
  props: {
    // 来源
    source: {
      type: String,
      default: ''
    },

    // 模块 item
    sourceItem: {
      type: Object,
      default: () => { }
    },

    // 公共查询
    filterData: {
      type: Object,
      default: () => { }
    },

    // 子查询
    filterSondata: {
      type: Object,
      default: () => { }
    },

    // 数据
    sourceData: {
      type: Object,
      default: () => { }
    },

    // 是否后台分页 1=后台分   0=前台分
    isPage: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      // 自定义表头
      headerObj: {
        'header_view_code': this.sourceItem.code
      },
      // 自定义列数组 parent是默认展示的父级全量数据 child存放的是添加自定义列时默认勾选的数据
      recordsList: {
        parent: [],
        child: []
      },
      filterList: [],
      currentFilterId: '', // 当前应用的筛选

      // 表格
      originalCaseTable: [], // 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      tableTheadOptions: [],
      checkboxTitle: [],
      tableTheads: [],
      showSummary: false,
      footerData: {},
      footerDataTotalavg: {},

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      downloadLoading: false // 下载
    }
  },

  computed: {
    ...mapGetters(['transitionEnter']),
    // 筛选列表表
    tableList() {
      const caseTable = this.caseTable
      if (this.isPage == 1 && this.sourceData.totalPage) {
        this.total = this.sourceData.totalPage
        this.tableData = caseTable
        return this.tableData
      } else {
        this.total = caseTable.length
        // 将一维数组切割成二维数组
        this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
        this.tableData = this.handCaseTable[this.listQuery.pageNo - 1]
        return this.tableData
      }
    }
  },

  watch: {
    transitionEnter(val) {
      this.$refs.grayTable.doLayout()
    },
    sourceData(val) {
      // console.log('初始化11111111', this.sourceItem)
      this.init()
    },

    // 筛选table header
    checkboxTitle(valArr) {
      // console.log('11111',valArr)
      this.tableTheads = []

      this.$nextTick(() => {
        this.tableTheads = this.tableTheadOptions.filter(i => valArr.includes(i.property))
      })
      // console.log('2222',this.tableTheads)
    }
  },

  mounted() {
    if (this.source != 'download') {
      this.getFilter()
    }
    // 如果全局刷新了 清空已选自定义列
    Bus.$on('getModule', () => {
      const defaultFilter = this.filterList.find(item => item.isDefault == 1)
      this.currentFilterId = defaultFilter ? defaultFilter.id : ''
    })
  },

  methods: {
    handleCommandFilterList(e) {
      this.currentFilterId = e
      this.refresh(e)
    },

    // 保存表头
    handleSaveNorm(id, type) {
      console.log(id, type)
      console.log(this.sourceItem)
      this.currentFilterId = id
      this.getFilterList()
      if (type == 'add') {
        this.refresh(id)
      } else {
        // 如果是编辑成功后 要判断编辑的是否是 当前应用的筛选 如果是要刷新
        if (this.currentFilterId == id) {
          this.refresh(id)
        }
      }
    },

    handleSelectNorm(list) {
      console.log(list)
    },

    // 新建常用自定义列
    addNewNorm() {
      const defaultProperty = JSON.parse(JSON.stringify(this.recordsList.child))
      const headerProperty = defaultProperty.map(item => item.property)
      this.getParentChecked(headerProperty)
      this.$refs['norm'].init(defaultProperty, 'add')
    },

    // 初始化数据
    init() {
      this.checkboxTitle = []
      // console.log('初始化22222', this.sourceData)
      this.tableTheadOptions = this.sourceData.thead.map(v => {
        this.$set(v, 'show', true)
        return v
      })

      // this.checkboxTitle = JSON.parse(JSON.stringify(this.sourceData.thead))
      this.sourceData.thead.forEach(item => {
        this.checkboxTitle.push(item.property)
      })
      // console.log(this.checkboxTitle)

      this.caseTable = this.sourceData.tbody

      if (this.sourceData.pageNo && this.sourceData.pageSize) {
        this.listQuery.pageNo = this.sourceData.pageNo
        this.listQuery.pageSize = this.sourceData.pageSize
      } else {
        this.listQuery.pageNo = 1
        this.listQuery.pageSize = 10
      }

      if (this.sourceData.total) {
        // this.sourceData.total.timeStr = "汇总<br/>均值"
        this.footerData = this.sourceData.total
        this.showSummary = true
      } else {
        this.footerData = null
      }
      if (this.sourceData.totalavg) {
        this.footerDataTotalavg = this.sourceData.totalavg
      } else {
        this.footerDataTotalavg = null
      }

      this.originalCaseTable = JSON.parse(JSON.stringify(this.sourceData.tbody))
    },

    // 获取自定义筛选数据
    getFilter() {
      // 获取表格的自定义列内容
      get_header(this.headerObj).then(res => {
        if (res.code == 1) {
          res.data.parent.forEach(arr => {
            arr.show = true
            arr.children.forEach(item => {
              item.show = true
            })
          })
          res.data.child.forEach(arr => {
            arr.show = true
          })
          this.recordsList.parent = res.data.parent
          this.recordsList.child = res.data.child
        }
      })
      // 获取自定义筛选的列表
      this.getFilterList()
    },

    // 汇总
    summaryData(param) {
      var sums = []
      if (this.footerData) {
        var zongji = this.footerData
        var theads = param.columns
        for (var i = 0; i < theads.length; i++) {
          var istrue = false
          for (var j in zongji) {
            if (theads[i].property == j) {
              istrue = true

              if (i == 0) {
                sums[i] = (() => {
                  if (this.footerDataTotalavg != null && this.footerDataTotalavg[j]) {
                    const num = <span style='font-weight: bold;'><div style='float:left;width:110%;border-bottom:1px dashed #c9cfd4;padding-bottom:8px'>{this.footerData[j]}</div><div style='float:left;width:100%;padding-top:8px'>{this.footerDataTotalavg[j]}</div></span>
                    return num
                  } else {
                    const num = <span style='font-weight: bold;'>{this.footerData[j]}</span>
                    return num
                  }
                })()
              } else {
                sums[i] = (() => {
                  if (this.footerDataTotalavg != null) {
                    if (this.footerData[j] == '' || this.footerData[j] == null || this.footerData[j] == '-') {
                      this.footerData[j] = '-'
                    }

                    if (this.footerDataTotalavg[j] == '' || this.footerDataTotalavg[j] == null || this.footerDataTotalavg[j] == '-') {
                      this.footerDataTotalavg[j] = '-'
                    }

                    var num = <span><div style='float:left;width:110%;border-bottom:1px dashed #c9cfd4;padding-bottom:8px;height:24px'>
                      {this.footerData[j]}
                    </div><div style='float:left;width:100%;padding-top:8px;height:22px'>
                        {this.footerDataTotalavg[j]}
                      </div></span>
                    return num
                  } else {
                    const num = <span>{this.footerData[j]}</span>
                    return num
                  }
                })()
              }
            }
          }
          if (!istrue) {
            sums.push(theads[i].property)
          }
        }
      }
      return sums
    },

    getList() {
      var page = {
        pageNo: this.sourceData.pageSize != this.listQuery.pageSize ? 1 : this.listQuery.pageNo,
        pageSize: this.listQuery.pageSize
      }
      this.$emit('tableFilter', page)
    },

    // 根据已有指标判断父级指标是否要勾全选
    getParentChecked(headerProperty) {
      // headerProperty property数组
      const editProperty = []
      this.recordsList.parent.forEach(arr => {
        let nums = 0
        let disabledNums = 0

        arr.children.forEach(item => {
          if (headerProperty.includes(item.property)) {
            item.checked = true
            nums++
            item.disabled && disabledNums++
            // editProperty.push(item)
            editProperty[headerProperty.findIndex(headerItem => headerItem == item.property)] = item
          } else {
            item.checked = false
          }
        })

        if (nums == arr.children.length) {
          arr.checked = true
          disabledNums == nums && (arr.disabled = true)
        } else {
          arr.checked = false
          arr.disabled = false
        }
      })
      console.log(this.recordsList)
      return JSON.parse(JSON.stringify(editProperty))
    },

    // 编辑筛选
    filterEdit(filterItem) {
      console.log(filterItem)
      // 编辑时只有property以逗号分隔的字符串的数据 所以要自定义构造出对象数组给 normFilter组件使用
      filterItem.filter = this.getParentChecked(filterItem.headerProperty.split(','))
      // const propertyStr = filterItem.filter.flatMap(item => [item.property])
      // this.$refs['norm'].sourceData = data
      console.log(JSON.parse(JSON.stringify(filterItem)))
      this.$nextTick(() => {
        this.$refs['norm'].init(filterItem, 'edit', this.filterList.length)
      })
    },

    // 向上刷新数据
    refresh(id) {
      console.log(id, '这里要向上refresh了')
      console.log(this.sourceItem)
      this.sourceItem.header_property_id = id
      this.$emit('handleResh', this.sourceItem)
    },

    // 设为默认
    setDefault(item) {
      console.log(item)
      // 每次设为默认后 把该条数据移到第一条
      let defaultIndex
      this.filterList.forEach((filterItem, index) => {
        filterItem.isDefault = 0
        if (filterItem.id == item.id) {
          defaultIndex = index
          filterItem.isDefault = 1
        }
      })
      this.filterList.unshift(this.filterList[defaultIndex])
      this.filterList.splice(defaultIndex + 1, 1)
      default_header(item, this.headerObj).then(res => {
        if (res.code == 1) {
          this.$message.success('默认自定义列设置成功')
        }
      })
    },

    // 获取自定义筛选列表
    getFilterList() {
      get_headerList(this.headerObj).then(res => {
        if (res.code == 1) {
          this.filterList = res.data
          if (!this.currentFilterId) {
            const defaultFilter = this.filterList.find(item => item.isDefault == 1)
            this.currentFilterId = defaultFilter ? defaultFilter.id : ''
          }
        }
      })
    },

    // 已有筛选删除
    filterDelete(item) {
      console.log(item)
      this.$confirm('是否确认删除自定义列模板: ' + item.name + '？', '删除自定义列', {
        customClass: 'delete-message',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delete_header(item.id).then(res => {
          if (res.code == 1) {
            this.$message.success('删除成功')
            this.filterList.splice(this.filterList.findIndex(i => i.id == item.id), 1)
            // 如果删的是默认 把第一条数据设为默认
            if (item.isDefault && this.filterList.length > 0) {
              this.filterList[0].isDefault = 1
              default_header(this.filterList[0], this.headerObj)
            }

            // 如果删的是当前选中 把第一条数据设为当前选中
            if ((this.currentFilterId == item.id) && this.filterList.length > 0) {
              this.currentFilterId = this.filterList[0].id
              this.refresh(this.filterList[0].id)
            } else if (this.filterList == 0) {
              this.currentFilterId = ''
              this.refresh('')
            }
          }
        })
      }).catch((err) => { })
    },

    // 监听排序变化
    handleAgeSortChange(e) {
      // console.log(e)
      if (e.order) {
        const order = e.order != 'descending'
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },

    // 下载
    async handleDownload() {
      // console.log('下载：',this.sourceItem)
      this.downloadLoading = true
      if (this.sourceItem.extra && this.sourceItem.extra.download) { // 接口下载
        const headerObj = {
          'header_view_code': this.sourceItem.code,
          'header_time_type': this.sourceItem.timeType,
          'header_property_id': this.currentFilterId || null
        }

        for (var key in this.filterData) { // 公共查询
          if (this.filterData.hasOwnProperty(key) === true) {
            headerObj[key] = this.filterData[key]
          }
        }

        console.log('下载====', headerObj, this.filterSondata)

        await houtaixiazai(headerObj, this.filterSondata)

        this.downloadLoading = false
      } else { // 本地下载
        // 多级表头
        if (this.sourceItem.kpiType == 11) {
          try {
            const $table = this.$refs['report-table'].$el
            const wb = XLSX.utils.table_to_book($table, { raw: false })
            const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
            FileSaver.saveAs(
              new Blob([wbout], { type: 'application/octet-stream' }),
              `${this.sourceItem.name}.xlsx`,
            )
          } catch (e) {
            if (typeof console !== 'undefined') console.error(e)
          }

          this.downloadLoading = false
        } else {
          // 普通表格
          import('@/vendor/Export2Excel').then(excel => {
            const tHeader = [] // 主表头名
            const filterVal = [] // 过滤表头

            this.tableTheads.forEach(v => {
              filterVal.push(v.property)
              tHeader.push(v.label)
            })
            var tables = JSON.parse(JSON.stringify(this.caseTable))
            // console.log('汇总===', this.footerData)
            if (this.footerData) {
              tables.push(this.footerData)
            }
            if (this.footerDataTotalavg) {
              tables.push(this.footerDataTotalavg)
            }

            const list = tables
            const data = this.formatJson(filterVal, list)

            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: this.sourceItem.name, // 文件名
              autoWidth: true, // 自适应宽
              bookType: 'xlsx'
            })

            this.downloadLoading = false
          })
        }

        // import('@/vendor/Export2Excel').then(excel => {
        //     let tHeader = [] // 主表头名
        //     let sonHeader = [] // 子表头名
        //     let filterVal = [] // 过滤表头
        //     let isMulti = false
        //     this.tableTheads.forEach(v => {
        //         if(v.list && v.list.length > 0) {
        //             isMulti = true
        //             tHeader.push(v.label)

        //             v.list.forEach((son,index) => {
        //                 filterVal.push(son.property)
        //                 sonHeader.push(son.label)
        //                 if(index < v.list.length - 1) {
        //                     tHeader.push('')
        //                 }
        //             })
        //         } else {
        //             filterVal.push(v.property)
        //             tHeader.push(v.label)
        //             sonHeader.push('')
        //         }
        //     });
        //     const list = this.caseTable
        //     const data = this.formatJson(filterVal, list)
        //     const merges = ['A1:A2', 'B1:D1', 'E1:G1','H1:J1']
        //     if(!isMulti) {
        //         excel.export_json_to_excel({
        //             header: tHeader,
        //             data,
        //             filename: this.sourceItem.name, // 文件名
        //             autoWidth: true, // 自适应宽
        //             bookType: 'xlsx'
        //         })

        //         this.downloadLoading = false
        //     } else { // 多级表头
        //         excel.export_json_to_excel({
        //             multiHeader: [tHeader],
        //             header: sonHeader,
        //             data,
        //             filename: this.sourceItem.name, // 文件名
        //             merges,
        //             autoWidth: true, // 自适应宽
        //             bookType: 'xlsx'
        //         })
        //     }
        // })
      }
    },

    // 过滤下载数据
    formatJson(filterVal, jsonData) {
      // console.log('222:',filterVal)
      return jsonData.map(v => filterVal.map(j => {
        var reg1 = /^(\-)?\d+(\.\d{1,2})?$/
        var val = String(v[j]).replace(/<[^>]+>/g, '')
        if (reg1.test(val)) {
          return parseFloat(val)
        } else {
          return val
        }
      }))
    },

    // 刷新
    handleResh() {
      this.$emit('handleResh')
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
}
.left-filter {
  justify-content: flex-start;
}
.filterTableHeader {
  margin-right: 10px;
}
.checkboxScrollList {
  max-height: 300px;
  overflow-y: auto;
}
.checkbox-table-headers {
  ::v-deep .el-checkbox {
    width: 125px;
  }
  ::v-deep .el-checkbox__label {
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}

.grayTableTile ::v-deep .el-table__body-wrapper {
  z-index: 1;
}

.grayTableTile {
  // min-height: 300px;
  ::v-deep .cell {
    position: relative;
    padding: 0 5px !important;
    line-height: 16px;
  }
  ::v-deep .caret-wrapper {
    position: absolute;
    top: -7px;
    right: 0;
  }
}
.dropdown-add {
  width: 200px;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 6px 20px;
  color: #3a89ff;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #ebf3ff;
  }
}
.more-dropdown {
  margin-top: 4px !important;
  border-radius: 8px;
  ::v-deep .popper__arrow {
    display: none;
  }
  ::v-deep .el-dropdown-menu__item {
    padding: 2px 20px;
  }
  .item-name {
    display: flex;
    max-width: 120px;
    white-space: nowrap;
    align-items: center;
  }
  ::v-deep .el-dropdown-menu__item {
    padding: 2px 20px;
    &.current {
      background-color: #ebf3ff;
      color: #61a1ff !important;
    }
  }
  ::v-deep .el-dropdown-menu__item:not(.is-disabled):hover,
  .el-dropdown-menu__item:focus {
    background: #ebf3ff;
    color: #333333;
  }
  i:hover {
    color: #3a89ff;
  }
}
</style>
